export default "__VITE_ASSET__Pap3q31p__"